import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IFlutterHomeSlide, IFlutterHomeState } from '../types';
import { IBranches, IProducts } from '../../interfaces/home';
import { IBranchesList } from '../../interfaces/content';

const initialState: IFlutterHomeState = {
  slides: [],
  products: [],
  branches: [],
};

const flutterHomeSlice = createSlice({
  name: 'flutterHome',
  initialState,
  reducers: {
    reset: () => initialState,

    addSlides: (
      state: Draft<IFlutterHomeState>,
      action: PayloadAction<IFlutterHomeSlide[]>
    ) => {
      state.slides = action.payload;
    },
    addProducts: (
      state: Draft<IFlutterHomeState>,
      action: PayloadAction<IProducts[]>
    ) => {
      state.products = action.payload;
    },
    addBranches: (
      state: Draft<IFlutterHomeState>,
      action: PayloadAction<IBranchesList[]>
    ) => {
      state.branches = action.payload;
    },
  },
});

export const { addSlides, addProducts, addBranches } = flutterHomeSlice.actions;
export default flutterHomeSlice.reducer;
